<template>
  <div class="experiments">
    <v-row v-if="current.user_level=='ADMIN'">
      <v-col class="d-flex justify-start">
        <v-btn class="ml-auto mr-3 green lighten-4" @click="dialog_add_experiment = !dialog_add_experiment">
          <v-icon left> mdi-plus </v-icon>
          {{ $t("manage.by_admin.experiments.add_experiment_btn") }}
        </v-btn>
      </v-col>
    </v-row>
    <v-data-table
      dense
      :locale="localeTranslate()"
      :headers="tableHeader()" 
      :items="api.experiments" 
      item-key="id"        
      :items-per-page="-1"
      :sort-by="[ 'experiment']"
      :sort-desc="[ false]"
      multi-sort
    >      
      <template v-slot:[`item.actions`]="{ item }">
        <!--v-icon color="" small class="mr-2" @click="1">mdi-pencil</v-icon-->        
        <v-tooltip top color="indigo">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" @click="openManualDialog(item)">
              <v-icon small color="indigo"> mdi-file-document-outline </v-icon>
            </v-btn>
          </template>
          <span>{{ $t("manage.by_admin.experiments.btn_lab_manual") }}</span>
        </v-tooltip>
        <v-tooltip top color="green">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" @click="openPhotoDialog(item)">
              <v-icon small color="green"> mdi-image </v-icon>
            </v-btn>
          </template>
          <span>{{ $t("manage.by_admin.experiments.btn_setup_photo") }}</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <v-dialog v-model="dialog_add_experiment" max-width="700px">
      <v-card>
        <v-toolbar dark color="green">
          <v-btn icon dark @click="dialog_add_experiment = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t("manage.by_admin.experiments.add_experiment.header") }}</v-toolbar-title>
        </v-toolbar>
        <v-row justify="center" no-gutters>
          <v-col cols="11" class="my-2 px-1">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  dense
                  :label="newExperimentLabel('id')"
                  v-model="form.new_experiment"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  dense
                  :label="newExperimentLabel('name')"
                  v-model="form.new_experiment_name"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-select
                  :items="fields"
                  :item-text="newExperimentLabel('field_text')"
                  item-value="value"
                  v-model="form.new_experiment_field"
                  :label="newExperimentLabel('field')"
                >

                </v-select>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="addNewExperiment">
                {{ $t("manage.by_admin.experiments.add_experiment.add_btn") }}
              </v-btn>
            </v-card-actions>
          </v-col>
        </v-row>
        <v-divider></v-divider>
      </v-card>
    </v-dialog>
    <v-dialog v-model="manualDialog" persistent max-width="700px" >
      <v-card class="pb-3">
        <v-toolbar dark color="green">
          <v-btn icon dark @click="closeManualDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t("manage.by_admin.experiments.lab_manual.header") }}</v-toolbar-title>
        </v-toolbar>
        <v-row justify="center" no-gutters>
          <v-col cols="11"  class="my-2 px-1">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  dense
                  :items="api.experiments"
                  item-text="experiment"
                  item-value="experiment"
                  v-model="manualForm.experiment"
                  :label="labManualManage('select_text')"
                  no-data-text="No Experiment Available"
                  readonly
                ></v-text-field>
                <hr>
              </v-col>
              <v-col cols="12">
                <div v-if="manualForm.old_file_path_chi!=null || manualForm.old_file_path_en!=null">
                  <v-card class="p-1">
                    <h6 class="m-2 mb-0">{{ $t("manage.by_admin.experiments.lab_manual.header") }}</h6>
                    <v-card-text class="p-1">
                      <v-row>
                        <v-col class="" cols="12">
                          <v-card>
                            <div v-if="manualForm.old_file_path_chi!=null">
                              <a class="body-2" :href="manualForm.old_file_path_chi" target="_BLANK"><v-icon class="p-1" color="primary">mdi-file-document-outline</v-icon>{{ manualForm.old_file_name_chi }} {{ $t("manage.by_school.experiment.list.lab_manual.language.chinese") }}</a>                          
                            </div>
                            <div v-if="manualForm.old_file_path_en!=null">
                              <a class="body-2" :href="manualForm.old_file_path_en" target="_BLANK"><v-icon class="p-1" color="primary">mdi-file-document-outline</v-icon>{{ manualForm.old_file_name_en }} {{ $t("manage.by_school.experiment.list.lab_manual.language.english") }}</a>                          
                            </div>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <br>
                      <v-btn class="mr-3" @click="openRemoveManualDialog">
                        <v-icon>mdi-delete</v-icon>{{ $t("manage.by_admin.experiments.lab_manual.btn_remove") }}
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn class="mr-3" color="primary" @click="uploadNewManualDialog=true">
                        <v-icon>mdi-upload</v-icon>{{ $t("manage.by_admin.experiments.lab_manual.btn_upload_new") }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </div>
                <div v-else-if="manualForm.old_file_path_chi==null && manualForm.old_file_path_en==null">
                  <v-card class="p-1">
                    <div class="red--text" color="red">
                      <v-icon color="red">mdi-file-outline</v-icon>{{ $t("manage.by_admin.experiments.lab_manual.no_lab_manual") }}
                    </div>
                  </v-card>
                  <br>
                  <v-card class="p-2">
                    <h6>{{ $t("manage.by_admin.experiments.lab_manual.upload_header") }}</h6>                    
                    <v-card-text class="p-1">
                      <v-row>
                        <v-col cols="12">
                          <v-select
                            v-if="$i18n.locale=='tc'"
                            :items="languages_chi"
                            item-text="text"
                            item-value="value"
                            v-model="manualForm.language"
                            label="實驗手冊語言"
                            prepend-icon="mdi-web"
                          ></v-select>
                          <v-select
                            v-else
                            :items="languages"
                            item-text="text"
                            item-value="value"
                            v-model="manualForm.language"
                            label="Lab Manual Language"
                            prepend-icon="mdi-web"
                          ></v-select>
                        </v-col>
                        <v-col cols="12">
                          <v-file-input
                            chips
                            accept="text/pdf"
                            :label="uploadNewLabManualLabel('file')"
                            :placeholder="uploadNewLabManualLabel('file_place_hloder')"
                            prepend-icon="mdi-paperclip"
                            v-model="manualForm.new_file"
                          >
                          <template v-slot:selection="{ text }">
                              <v-chip small color="primary">
                                {{ text }}
                              </v-chip>
                            </template>
                          </v-file-input>
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" @click="uploadSuggestedExperimentLabManual">
                        <v-icon>mdi-upload</v-icon>{{ $t("manage.by_admin.experiments.lab_manual.upload_new.btn_upload") }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </div>
                <v-card v-else>Error</v-card>
              </v-col>
            </v-row>
          </v-col>
          <!--vue-pdf-embed :source="pdfSource" /-->
        </v-row>
      </v-card>
    </v-dialog>    
    <v-dialog v-model="removeManualDialog" persistent max-width="500px" >
      <v-card>
        <v-card-title class="headline red accent-1">
          {{ $t("manage.by_admin.experiments.lab_manual.remove.header") }}
        </v-card-title>
          <v-alert
            >{{ $t("manage.by_admin.experiments.lab_manual.remove.alert") }}<br>{{ manualForm.experiment }}
          </v-alert>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mr-3" @click="closeRemoveManualDialog">{{ $t("manage.by_admin.experiments.lab_manual.remove.btn_cancel") }}</v-btn>
          <v-btn class="mr-3" @click="removeSuggestedExperimentLabManual">{{ $t("manage.by_admin.experiments.lab_manual.remove.btn_confirm") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="uploadNewManualDialog" persistent max-width="600px" >
      <v-card>
        <v-card-title class="headline green white--text" >
          {{ $t("manage.by_admin.experiments.lab_manual.upload_new.header") }}
        </v-card-title>
        <v-card-text class="pt-2 pb-0">
          <v-row>
            <v-col cols="12">
              <v-text-field
                dense
                :items="api.experiments"
                item-text="experiment"
                item-value="experiment"
                v-model="manualForm.experiment"
                :label="uploadNewLabManualLabel('select_text')"
                no-data-text="No Experiment Available"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-select
                v-if="$i18n.locale=='tc'"
                :items="languages_chi"
                item-text="text"
                item-value="value"
                v-model="manualForm.language"
                label="實驗手冊語言"
                prepend-icon="mdi-web"
              ></v-select>
              <v-select
                v-else
                :items="languages"
                item-text="text"
                item-value="value"
                v-model="manualForm.language"
                label="Lab Manual Language"
                prepend-icon="mdi-web"
              ></v-select>
            </v-col>
            <v-col cols="12">
              <v-file-input
                chips
                accept="text/pdf"
                :label="uploadNewLabManualLabel('file')"
                :placeholder="uploadNewLabManualLabel('file_place_hloder')"
                prepend-icon="mdi-paperclip"
                v-model="manualForm.new_file"
              >
                <template v-slot:selection="{ text }">
                  <v-chip small color="primary">
                    {{ text }}
                  </v-chip>
                </template>
              </v-file-input>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mr-3" @click="closeUploadNewManualDialog">{{ $t("manage.by_admin.experiments.lab_manual.upload_new.btn_cancel") }}</v-btn>
          <v-btn color="primary" @click="uploadSuggestedExperimentLabManual">
            <v-icon>mdi-upload</v-icon>{{ $t("manage.by_admin.experiments.lab_manual.upload_new.btn_upload") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="photoDialog" persistent max-width="700px" >
      <v-card class="pb-3">
        <v-toolbar dark color="green">
          <v-btn icon dark @click="closePhotoDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t("manage.by_admin.experiments.setup_photo.header") }}</v-toolbar-title>
        </v-toolbar>
        <v-row justify="center" no-gutters>
          <v-col cols="11"  class="my-2 px-1">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  dense
                  :items="api.experiments"
                  item-text="experiment"
                  item-value="experiment"
                  v-model="photoForm.experiment"
                  :label="uploadNewSetupPhotoLabel('select_text')"
                  no-data-text="No Experiment Available"
                  readonly
                ></v-text-field>
                <hr>
              </v-col>
              <v-col cols="12">
                <div v-if="photoForm.exist">
                  <v-card class="p-1">
                    <h6 class="m-2 mb-0">{{ $t("manage.by_admin.experiments.setup_photo.upload_header") }}</h6>
                    <v-card-text class="p-1">
                      <v-row>
                        <v-col class="" cols="12">
                          <v-card>
                            <div v-for="(item, i) in photoForm.photos" :key="i">
                              <v-icon class="p-1" color="primary">mdi-image-outline</v-icon><a :href="item.src" target="_BLANK">{{ item.filename }}</a>
                            </div>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <br>
                      <v-btn class="mr-3" @click="openRemoveAllPhotoDialog">
                        <v-icon>mdi-delete</v-icon>{{ $t("manage.by_admin.experiments.setup_photo.btn_remove_all") }}
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn class="mr-3" color="primary" @click="uploadNewPhotoDialog=true">
                        <v-icon>mdi-upload</v-icon>{{ $t("manage.by_admin.experiments.setup_photo.btn_upload_new") }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </div>
                <div v-else-if="photoForm.exist==false">
                  <v-card class="p-1">
                    <div class="red--text" color="red">
                      <v-icon color="red">mdi-file-outline</v-icon>{{ $t("manage.by_admin.experiments.setup_photo.no_setup_photo") }}
                    </div>
                  </v-card>
                  <br>
                  <v-card class="p-2">
                    <h6>{{ $t("manage.by_admin.experiments.setup_photo.upload_header") }}</h6>                    
                    <v-card-text class="p-1">
                      <v-row>
                        <v-col cols="12">
                          <!--v-file-input
                            accept="text/pdf"
                            label="File input"
                            placeholder="Select your lab manual in pdf format"
                            v-model="manualForm.new_file"
                          >
                          </v-file-input-->
                          <v-file-input
                            chips
                            accept="image/*"
                            multiple
                            :label="uploadNewSetupPhotoLabel('file')"
                            :placeholder="uploadNewSetupPhotoLabel('file_place_hloder')"
                            prepend-icon="mdi-paperclip"
                            v-model="photoForm.new_photos"
                          >
                            <template v-slot:selection="{ text }">
                              <v-chip small color="primary">
                                {{ text }}
                              </v-chip>
                            </template>
                          </v-file-input>
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" @click="uploadSuggestedExperimentPhoto">
                        <v-icon>mdi-upload</v-icon>{{ $t("manage.by_admin.experiments.setup_photo.upload_new.btn_upload") }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </div>
                <v-card v-else>Error</v-card>
              </v-col>
            </v-row>
          </v-col>
          <!--vue-pdf-embed :source="pdfSource" /-->
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="removeAllPhotoDialog" persistent max-width="500px" >
      <v-card>
        <v-card-title class="headline red accent-1">
          {{ $t("manage.by_admin.experiments.setup_photo.remove.header") }}
        </v-card-title>
          <v-alert
            >{{ $t("manage.by_admin.experiments.setup_photo.remove.alert") }}<br>{{ photoForm.experiment }}
          </v-alert>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mr-3" @click="closeRemoveAllPhotoDialog">{{ $t("manage.by_admin.experiments.setup_photo.remove.btn_cancel") }}</v-btn>
          <v-btn class="mr-3" @click="removeSuggestedExperimentPhoto">{{ $t("manage.by_admin.experiments.setup_photo.remove.btn_confirm") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="uploadNewPhotoDialog" persistent max-width="600px" >
      <v-card>
        <v-card-title class="headline green white--text">
          {{ $t("manage.by_admin.experiments.setup_photo.upload_new.header") }}
        </v-card-title>
        <v-card-text class="pt-2 pb-0">
          <v-row>
            <v-col cols="12">
              <v-text-field
                dense
                :items="api.experiments"
                item-text="experiment"
                item-value="experiment"
                v-model="photoForm.experiment"
                :label="uploadNewSetupPhotoLabel('select_text')"
                no-data-text="No Experiment Available"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <!--v-file-input
                accept="text/pdf"
                label="File input"
                placeholder="Select your lab manual in pdf format"
                v-model="manualForm.new_file"
              >
              </v-file-input-->
              <v-file-input
                chips
                accept="image/*"
                multiple
                :label="uploadNewSetupPhotoLabel('file')"
                :placeholder="uploadNewSetupPhotoLabel('file_place_hloder')"
                prepend-icon="mdi-paperclip"
                v-model="photoForm.new_photos"
              >
                <template v-slot:selection="{ text }">
                  <v-chip small color="primary">
                    {{ text }}
                  </v-chip>
                </template>
              </v-file-input>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mr-3" @click="closeUploadNewPhotoDialog">{{ $t("manage.by_admin.experiments.setup_photo.upload_new.btn_cancel") }}</v-btn>
          <v-btn color="primary" @click="uploadSuggestedExperimentPhoto">
            <v-icon>mdi-upload</v-icon>{{ $t("manage.by_admin.experiments.setup_photo.upload_new.btn_upload") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { api_management } from "@/services/iot/api_management";
const apiManagement = new api_management(process.env.VUE_APP_BASE_URL);
export default {
  name: "CreateBookSlot",
  data: function () {
    return {
      languages_chi: [
        { text: "中文", value: "chinese" },
        { text: "英文", value: "english" },
      ],
      languages: [
        { text: "Chinese", value: "chinese" },
        { text: "English", value: "english" },
      ],
      assignCheckbox: false,
      menu: false,
      dialog: false,
      dialog_add_experiment: false,
      manualDialog: false,
      removeManualDialog: false,
      uploadNewManualDialog: false,
      manualItem: null,
      photoDialog: false,
      removeAllPhotoDialog: false,
      uploadNewPhotoDialog: false,
      photoItem: null,
      fields: [
        {
          text:"BIOLOGY",
          text_chi: "生物",
          value:"Biology"
        },
        {
          text:"CHEMISTRY",
          text_chi: "化學",
          value:"Chemistry"
        },
        {
          text:"PHYSICS",
          text_chi: "物理",
          value:"Physics"
        },
        {
          text:"ENGINEERING",
          text_chi: "工程",
          value:"Engineering"
        },
      ],
      current:{
        school_id: null,
        username: null,
        user_level: "USER",
        auth_token: null,
      },      
      manualForm:{
        experiment: "",
        language: null,
        old_file_path: "",
        old_filename: "",
        new_file: null,
        exist: false,
        old_file_path_chi: null,
        old_file_name_chi: null,
        old_file_path_en: null,
        old_file_name_en: null,

      },
      photoForm:{
        experiment: "",
        photos: [],
        new_photos: null,
        exist: false,
      },
      api: {
        experiments: [],
      },
      form: {
        new_experiment: "",
        new_experiment_name: "",
        new_experiment_field: "",
      },
      headers: [
        { text: 'Field', value: 'field' },
        { text: 'Experiment ID', value: 'experiment' },
        { text: 'Experiment Name', value: 'experiment_name' },
        { text: 'Experiment Chinese Name', value: 'experiment_name_chi' },
        { text: 'Status', value: 'status' },
        { text: 'Created at', value: 'create_at' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      headers_chi: [
        { text: '領域', value: 'field_chi' },
        { text: '實驗ID', value: 'experiment' },
        { text: '英文名稱', value: 'experiment_name' },
        { text: '中文名稱', value: 'experiment_name_chi' },
        { text: '狀態', value: 'status_chi' },
        { text: '創建於', value: 'create_at' },
        { text: '操作', value: 'actions', sortable: false },
      ],
    };
  },
  mounted: function () {
    var self = this;
    self.current.school_id = self.$route.params.school_id;
    self.current.username = self.$store.state.user.username;
    self.current.user_level = self.$store.state.user.user_level;
    self.current.auth_token = self.$store.state.user.auth_token;
    self.getExperimentList();
  },  
  methods: {
    localeTranslate(){
      var self = this;
      if(self.$i18n.locale=='tc') return 'zh-tw';
      else return 'en';
    },
    isValid: function(){
      var self = this;
      if(self.form.new_experiment.trim()==""){
        alert("Missing experiment ID");
        return false;
      }
      if(self.form.new_experiment_name.trim()==""){
        alert("Missing experiment name");
        return false;
      }
      if(self.form.new_experiment_field==""){
        alert("Missing experiment field");
        return false;
      }
      return true;
    },
    addNewExperiment(){
      var self = this;
      if(self.isValid()){
        apiManagement.addNewExperiment(self.form.new_experiment, self.form.new_experiment_name, self.form.new_experiment_field, self.current.username, self.current.auth_token)
        .then((response) =>{
          if(response.status=="success"){
            self.$store.commit("showSnackBar", "New Experiment has been added");
            self.dialog_add_experiment = !self.dialog_add_experiment;
            self.form.new_experiment_field = "";
            self.form.new_experiment = "";
            self.form.new_experiment_name = "";
            self.getExperimentList();
          }
          else if(response.status=="fail"){
            self.$store.commit("showSnackBar", response.message);
          }
        });
      }
    },
    newExperimentLabel(label){
      var self = this;
      if(self.$i18n.locale=='tc'){
        if (label=='id') return "實驗ID"
        else if (label=='name') return "英文全名"
        else if (label=='field') return "領域"
        else if (label=='field_text') return "text_chi"
      }
      else {
        if (label=='id') return "Experiment ID"
        else if (label=='name') return "Experiment Name"
        else if (label=='field') return "Field"
        else if (label=='field_text') return "text"
      }
    },    
    uploadNewSetupPhotoLabel(label){
      var self = this;
      if(self.$i18n.locale=='tc'){
        if (label=='select_text') return "實驗ID"
        else if (label=='file') return "新檔案"
        else if (label=='file_place_hloder') return "選擇圖像格式的檔案"
        else if (label=='field_text') return "text_chi"
      }
      else {
        if (label=='select_text') return "Experiment ID"
        else if (label=='file') return "New File Input"
        else if (label=='file_place_hloder') return "Select file in image format"
        else if (label=='field_text') return "text"
      }
    },
    uploadNewLabManualLabel(label){
      var self = this;
      if(self.$i18n.locale=='tc'){
        if (label=='select_text') return "實驗ID"
        else if (label=='file') return "新檔案"
        else if (label=='file_place_hloder') return "選擇PDF格式的檔案"
        else if (label=='field_text') return "text_chi"
      }
      else {
        if (label=='select_text') return "Experiment ID"
        else if (label=='file') return "New File Input"
        else if (label=='file_place_hloder') return "Select file in PDF format"
        else if (label=='field_text') return "text"
      }
    },
    labManualManage(label){
      var self = this;
      if(self.$i18n.locale=='tc'){
        if (label=='select_text') return "實驗ID"
        else if (label=='field') return "領域"
        else if (label=='field_text') return "text_chi"
      }
      else {
        if (label=='select_text') return "Experiment ID"
        else if (label=='field') return "Field"
        else if (label=='field_text') return "text"
      }
    },
    tableHeader(){
      var self = this;
      if(self.$i18n.locale=='tc')
        return self.headers_chi;
      else
        return self.headers;
    },
    getExperimentList(){
      var self = this;
      apiManagement.getExperimentList().then((response) => {
        self.api.experiments = response.experiments;
      });
    },
    closeDialog() {
      this.$emit("update-parent-dialog", false);
    },
    openManualDialog(item){
      var self = this;
      self.manualItem = item;
      self.manualDialog = true;
      self.manualForm.experiment = item.experiment;
      self.manualForm.language = "",
      self.manualForm.new_file = null;
      apiManagement.getSuggestedExperimentLabManual(item.experiment)
      .then((response) => {
        self.manualForm.old_file_path = response.file_path;
        self.manualForm.old_filename = response.filename;
        self.manualForm.exist = response.exist;
        self.manualForm.old_file_path_chi = response.suggested_chi.path;
        self.manualForm.old_file_name_chi = response.suggested_chi.filename;
        self.manualForm.old_file_path_en = response.suggested_en.path;
        self.manualForm.old_file_name_en = response.suggested_en.filename;
        console.log(self.manualForm);
      });
    }, 
    closeManualDialog(){
      var self = this;
      self.manualDialog = false;
      self.manualForm.school_id = "";
      self.manualForm.experiment = "";
      self.manualForm.equipment_id = "";
      self.manualForm.experiment_set = "";
      self.manualForm.old_file_path = "";
      self.manualForm.old_filename = "";
      self.manualForm.old_file_path_chi = null;
      self.manualForm.old_file_name_chi = null;
      self.manualForm.old_file_path_en = null;
      self.manualForm.old_file_name_en = null;
      self.manualForm.language = "";
      self.manualForm.new_file = null;
      self.manualForm.exist = false;
      self.manualItem = null;
    },
    openRemoveManualDialog(){
      var self = this;
      self.removeManualDialog = true;
    },
    closeRemoveManualDialog(){
      var self = this;
      self.removeManualDialog = false;
    },
    closeUploadNewManualDialog(){
      var self = this;
      self.uploadNewManualDialog = false;
      self.manualForm.new_file = null;
    },    
    uploadSuggestedExperimentLabManual(){
      var self = this;
      if(self.manualForm.new_file){
        if(self.manualForm.language == 'chinese' || self.manualForm.language == 'english'){
          apiManagement.uploadSuggestedExperimentLabManual(self.manualForm.experiment, self.manualForm.new_file, self.current.username, self.current.auth_token, self.manualForm.language)
          .then((response) => {
            
            if(response.status == "success"){
                self.$store.commit("showSnackBar", "Lab manual is added");              
            }
            else if(response.status == "fail"){
                self.$store.commit("showSnackBar", response.error);
            }
            else {
              self.$store.commit("showSnackBar", "Error, please try again.");
            }
            self.openManualDialog(self.manualItem);
            self.closeUploadNewManualDialog();
          });
        }
        else {
          if(self.$i18n.locale=='tc') alert("請選擇實驗手冊的語言。");
          else alert("Please select language of lab manual.");
        }
      }
      else {
        alert("Please select a pdf file");
      }
    },
    removeSuggestedExperimentLabManual(){
      var self = this;
      apiManagement.removeSuggestedExperimentLabManual(self.manualForm.experiment)
      .then((response) => {        
        if(response.status == "success"){
          self.$store.commit("showSnackBar", "Lab manual is removed");            
        }
        else if(response.status == "fail"){
          self.$store.commit("showSnackBar", response.error);            
        }
        else {
          self.$store.commit("showSnackBar", "Error, please try again.");
        }
        self.openManualDialog(self.manualItem);
        self.removeManualDialog = false;
      });
    },
    openPhotoDialog(item){
      var self = this;
      self.photoItem = item;
      self.photoDialog = true;
      self.photoForm.experiment = item.experiment;
      apiManagement.getSuggestedExperimentPhoto(item.experiment)
      .then((response) => {
        self.photoForm.photos = response.photos;
        self.photoForm.exist = response.exist;
      });      
    },    
    closePhotoDialog(){
      var self = this;
      self.photoDialog = false;
      self.photoForm.school_id = "";
      self.photoForm.experiment = "";
      self.photoForm.equipment_id = "";
      self.photoForm.experiment_set = "";
      self.photoForm.exist = false;
    },
    openRemoveAllPhotoDialog(){
      var self = this;
      self.removeAllPhotoDialog = true;
    },
    closeRemoveAllPhotoDialog(){
      var self = this;
      self.removeAllPhotoDialog = false;
    },
    closeUploadNewPhotoDialog(){
      var self = this;
      self.uploadNewPhotoDialog = false;
      self.photoForm.new_photos = null;
    },
    uploadSuggestedExperimentPhoto(){
      var self = this;
      if(self.photoForm.new_photos){
        apiManagement.uploadSuggestedExperimentPhoto(self.photoForm.experiment, self.photoForm.new_photos, self.current.username, self.current.auth_token)
        .then((response) => {          
          if(response.status == "success"){
              self.$store.commit("showSnackBar", "Setup photo is added");
          }
          else if(response.status == "fail"){
              self.$store.commit("showSnackBar", response.error);
          }
          else {
            self.$store.commit("showSnackBar", "Error, please try again.");
          }
          self.openPhotoDialog(self.photoItem);
          self.closeUploadNewPhotoDialog();
        });
      }
      else {
        alert("Please select image file");
      }
    },
    
    removeSuggestedExperimentPhoto(){
      var self = this;
      apiManagement.removeSuggestedExperimentPhoto(self.photoForm.experiment)
      .then((response) => {        
        if(response.status == "success"){
          self.$store.commit("showSnackBar", "Setup photos are removed");            
        }
        else if(response.status == "fail"){
          self.$store.commit("showSnackBar", response.error);            
        }
        else {
          self.$store.commit("showSnackBar", "Error, please try again.");
        }
        self.openPhotoDialog(self.photoItem);
        self.removeAllPhotoDialog = false;
      });
    },
    goTo(school_id){
      var self = this;
      self.$router.push("/management/school/"+school_id);
    },
  },
  watch: {},
};
</script>

<style scoped lang="scss">
</style>